import { App, TierartEnum } from '@ps20-frontend/frontend-models';
import { TgvTier, TgvTierUmfang, TiergruppePositions } from './tiergruppe.model';

export const THH_POSITION: Partial<Record<App, 'thhHund' | 'thhPferd'>> = {
  [App.THH_HUND]: 'thhHund',
  [App.THH_PFERD]: 'thhPferd',
};

export const THH_TIERART_OF: Partial<Record<App, TierartEnum>> = {
  [App.THH_HUND]: TierartEnum.HUND,
  [App.THH_PFERD]: TierartEnum.PFERD,
};

export const isThhAvailable = (tierart: TierartEnum | null): boolean =>
  tierart === TierartEnum.HUND || tierart === TierartEnum.PFERD;

export const defaultUmfang = (tierart: TierartEnum | null): TgvTierUmfang => ({
  tkv: tierart !== null,
  thh: isThhAvailable(tierart),
});

export const withoutThhCoverage = (animals: TgvTier[]): TgvTier[] =>
  animals.map(animal =>
    animal.umfang.thh ? { ...animal, umfang: { ...animal.umfang, thh: false } } : animal,
  );

/**
 * Every TKV selection is its own TKV V2 state (one animal each). All THH selections of one
 * Tierart share a single THH state, which can contain several animals.
 */
export const derivePositions = (tiere: TgvTier[]): TiergruppePositions => {
  const firstThhCardId = (tierart: TierartEnum): string | undefined =>
    tiere.find(tier => tier.tierart === tierart && tier.umfang.thh)?.cardId;
  const thhHundId = firstThhCardId(TierartEnum.HUND);
  const thhPferdId = firstThhCardId(TierartEnum.PFERD);
  return {
    tkvV2: tiere
      .filter(tier => tier.tierart !== null && tier.umfang.tkv)
      .map(tier => ({ positionId: tier.cardId })),
    thhHund: thhHundId === undefined ? null : { positionId: thhHundId },
    thhPferd: thhPferdId === undefined ? null : { positionId: thhPferdId },
  };
};
